import React, { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#zone", label: "Zone" },
  { href: "#realisations", label: "Réalisations" },
  { href: "#pourquoi", label: "Pourquoi nous" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-slate-200"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-2"
        >
          <img
            src="/assets/etancia-logo.png"
            alt="ETANCIA — Tous corps d'état"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-slate-700 hover:text-[#003366] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:0658116161"
            data-testid="navbar-call-btn"
            className="hidden md:inline-flex items-center gap-2 text-sm font-semibold text-[#003366] hover:text-[#FF5A1F] transition-colors"
          >
            <Phone className="w-4 h-4" /> 06 58 11 61 61
          </a>
          <a
            href="#contact"
            data-testid="navbar-devis-btn"
            className="hidden md:inline-flex items-center bg-[#FF5A1F] hover:bg-[#E04812] text-white text-sm font-semibold px-5 py-2.5 rounded-none transition-all hover:-translate-y-0.5 shadow-sm hover:shadow-md"
          >
            Devis gratuit
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-[#003366] p-2"
            aria-label="Ouvrir le menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-4">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-base font-medium text-slate-800 py-1 border-b border-slate-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="tel:0658116161"
              data-testid="mobile-navbar-call"
              className="flex items-center gap-2 text-sm font-semibold text-[#003366]"
            >
              <Phone className="w-4 h-4" /> 06 58 11 61 61
            </a>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-navbar-devis"
              className="inline-flex items-center justify-center bg-[#FF5A1F] text-white text-sm font-semibold px-5 py-3"
            >
              Devis gratuit
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
